import {DiDjango, DiReact, DiSass, DiJavascript1, DiBootstrap, DiPython, SiCplusplus, DiCss3} from "react-icons/all";
import baza from "../../data/images/baza.gif"
import notbadmovies from "../../data/images/notbadmovies.webp"
import billard from "../../data/images/billard.webp"
import openvc from "../../data/images/opencv.webp"
import autogracja from "../../data/images/autogracja.webp"
import AboutProject from "./AboutProject";
import "../../data/css/About.scss"
import {v4} from "uuid";

export default function About() {
    return (
        <div className={"container container-fluid w-100 aalp1"}>
            <h2 key={v4()} className={"title pb-0 text-center"}>About <span className={"color-special"}>me</span></h2>
            <h5 key={v4()} className={"text-center pb-5 color-gray"}>
                I'm fourth year student of computer science.<br/>
                I specialize in web app development.
            </h5>
            <div key={v4()} className={ "m-0 p-0 row container-fluid color-gray"}>
                <AboutProject key={v4()} img={baza} techstack={[DiPython, DiDjango, DiBootstrap, DiJavascript1]}
                              projectName={"Rejestr zgłoszeń"}/>
                <AboutProject key={v4()} img={notbadmovies} techstack={[DiReact, DiSass, DiBootstrap, DiJavascript1]}
                              projectName={"NotBadMovies"} href={"https://notbadmovies.jakubkwiatkowski.pl/"}/>
                <AboutProject key={v4()} img={autogracja} techstack={[DiCss3, DiBootstrap, DiJavascript1]}
                              projectName={"Autogracja"} href={"https://autogracja.pl/"}/>
                <AboutProject key={v4()} img={billard} techstack={[SiCplusplus]}
                              projectName={"Billard"} special={["SDL"]}/>
                <AboutProject key={v4()} img={openvc} techstack={[DiPython]} special={['CV2']}
                              projectName={"OpenCV projects"}/>
            </div>
        </div>
    );
}


